const STORAGE_KEY_PREFIX = 'sidebar_order'

export const saveSidebarOrder = (
  userId: string | number,
  sectionKey: string,
  order: string[]
) => {
  try {
    const key = `${STORAGE_KEY_PREFIX}_${userId}_${sectionKey}`
    localStorage.setItem(key, JSON.stringify(order))
  } catch (error) {
    console.error('Error saving sidebar order:', error)
  }
}

export const loadSidebarOrder = (
  userId: string | number,
  sectionKey: string
): string[] | null => {
  try {
    const key = `${STORAGE_KEY_PREFIX}_${userId}_${sectionKey}`
    const stored = localStorage.getItem(key)
    return stored ? JSON.parse(stored) : null
  } catch (error) {
    console.error('Error loading sidebar order:', error)
    return null
  }
}
